/* RESPONSIBLE TEAM: team-workflows */
import TaskBotBase from 'embercom/routes/apps/app/operator/task-bots';

export default TaskBotBase.extend({
  analytics: {
    place: 'task_bots_teammates',
    section: 'operator',
  },
});
